import { NavLink } from "react-router";
import { Orb } from "@/ui/Orb";
import { TABS } from "./tabs";

interface TabBarProps {
  /** Hide the bar on a phone (detail pages), keep the desktop sidebar. */
  readonly phone?: boolean;
}

/**
 * The five sections. On a phone: a row of letter-spaced labels along the
 * bottom, each a full 44pt tap target — a label whose hit area matched its
 * glyphs missed half the taps aimed at it. On a desktop: the same five,
 * stacked in a sidebar under the mark, because a bottom bar on a 27-inch
 * screen is a phone pretending.
 */
export function TabBar({ phone = true }: TabBarProps) {
  return (
    <nav
      aria-label="Sections"
      className={`${phone ? "flex" : "hidden md:flex"} sticky bottom-app justify-around border-t border-rule bg-paper pb-[env(safe-area-inset-bottom)] md:top-0 md:h-dvh md:w-60 md:shrink-0 md:flex-col md:justify-start md:gap-1 md:border-r md:border-t-0 md:px-8 md:pb-0 md:pt-12`}
    >
      <NavLink to="/today" className="mb-10 hidden items-center gap-3 md:flex" aria-label="Antar">
        <Orb size={28} />
        <span className="font-display text-[22px]">Antar</span>
      </NavLink>
      {TABS.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) =>
            `flex min-h-12 flex-1 items-center justify-center font-mono text-[10px] uppercase tracking-[0.18em] md:min-h-10 md:flex-none md:justify-start md:text-[11px] ${
              isActive ? "text-ink" : "text-mid"
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
